import { ServerSideEnum } from '../../enum/server-side-enum.model';
import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('BatchTaggingCriteriaType')
export class BatchTaggingCriteriaType extends ServerSideEnum {
  AttachedData: number;
  CalledCallerNumber: number;
  ConversationId: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
